(() => {
  'use strict';
  if (window.zbNewServiceFormsLoaded) return;
  window.zbNewServiceFormsLoaded = true;

  function initialize(root = document) {
    root.querySelectorAll('[data-zb-new-service]').forEach(widget => {
      if (widget.dataset.zbReady) return;
      widget.dataset.zbReady = '1';
      const dialog = widget.querySelector('dialog');
      const opener = widget.querySelector('[data-zb-help-open]');
      opener?.addEventListener('click', () => dialog.showModal());
      widget.querySelector('[data-zb-help-close]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog?.addEventListener('close', () => opener.focus());
      const links = widget.querySelector('[data-zb-links]');
      const firstRow = links.querySelector('.ig-input-group').cloneNode(true);
      const add = widget.querySelector('[data-zb-add-link]');
      function sync() {
        const fields = [...links.querySelectorAll('[data-zb-url]')];
        fields.forEach((input, index) => {
          input.name = `properties[🔗 LINK ${index + 1}]`;
          input.id = index ? `${widget.id}-url-${index + 1}` : `${widget.id}-url`;
          input.setAttribute('aria-label', `Link ${index + 1}`);
        });
        widget.querySelectorAll('.ig-transparent-input').forEach(input => input.closest('.ig-input-wrapper')?.classList.toggle('has-text', Boolean(input.value.trim())));
        if (add) add.hidden = fields.length >= 10;
        const status = widget.querySelector('[data-zb-count]');
        if (status) {
          const count = fields.filter(input => input.value.trim()).length;
          const words = ['instagram', 'facebook'].includes(widget.dataset.platform)
            ? ['post', 'posty', 'postów'] : ['film', 'filmy', 'filmów'];
          const noun = words[count === 1 ? 0 : count >= 2 && count <= 4 ? 1 : 2];
          status.textContent = `Wybrano ${count} ${noun}.`;
        }
      }
      add?.addEventListener('click', () => {
        if (links.querySelectorAll('[data-zb-url]').length >= 10) return;
        const row = firstRow.cloneNode(true), input = row.querySelector('[data-zb-url]');
        input.value = ''; input.defaultValue = ''; input.setCustomValidity('');
        const wrapper = row.querySelector('.ig-input-wrapper');
        wrapper.classList.add('ig-input-wrapper--removable');
        const remove = document.createElement('button');
        remove.type = 'button'; remove.className = 'ig-remove-field'; remove.textContent = '×';
        remove.dataset.zbRemoveLink = ''; remove.setAttribute('aria-label', 'Usuń link');
        wrapper.append(remove); links.append(row); sync(); input.focus();
      });
      widget.addEventListener('click', event => {
        const remove = event.target.closest?.('[data-zb-remove-link]');
        if (remove) { remove.closest('.ig-input-group').remove(); sync(); links.querySelector('[data-zb-url]').focus(); return; }
        const wrapper = event.target.closest?.('.ig-input-wrapper');
        if (wrapper && !event.target.matches('input,textarea')) wrapper.querySelector('input,textarea')?.focus();
      });
      widget.addEventListener('keydown', event => {
        if (event.key === 'Enter' && !event.isComposing && event.target.matches('input[type="text"]')) { event.preventDefault(); event.target.blur(); }
      });
      widget.addEventListener('input', event => {
        if (typeof event.target.setCustomValidity === 'function') event.target.setCustomValidity('');
        sync();
      });
      const form = document.getElementById(widget.dataset.form);
      if (form) form.noValidate = false;
      sync();
      document.dispatchEvent(new CustomEvent('zb:new-service-ready'));
    });
  }

  // Capture validation before the theme's native cart handler; never send a cart request here.
  function validate(form, event) {
    if (!(form instanceof HTMLFormElement)) return true;
    const formId = form.getAttribute('id');
    const widget = [...document.querySelectorAll('[data-zb-new-service]')].find(el => el.dataset.form === formId);
    if (!widget) return true;
    // Korzystamy wyłącznie z natywnego required, tak jak w starszych formularzach.
    if (!form.checkValidity()) {
      event.preventDefault(); event.stopImmediatePropagation();
      form.reportValidity();
      return false;
    }
    return true;
  }
  document.addEventListener('submit', event => validate(event.target, event), true);
  // The shop's second button goes directly to checkout; validate it before its handler.
  document.addEventListener('click', event => {
    const button = event.target.closest?.('.shopify-payment-button__button,[data-testid="Checkout-button"],[data-st-checkout]');
    if (button) validate(button.closest('form') || document.getElementById(button.getAttribute('form')), event);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  // Variant changes in Shopify can replace parts of product-info.
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-zb-new-service]') || node.querySelector?.('[data-zb-new-service]'))))) initialize();
  }).observe(document.body, {childList:true, subtree:true});
})();
